import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type CampaignRecommendationRequest } from '../types/apiRequest'
import { type CampaignRecommendationResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
  preload,
} = createRequestHelper<FortuneApis['get']['recommendations'], CampaignRecommendationResponse, CampaignRecommendationRequest>({
  client: 'fortune',
  key: (params) => {
    const { country_code, project_code, code, draft_name, order_id, order_item_id } = params || {}
    if (!country_code || !project_code || !code || !draft_name || !order_id) return null
    return `/campaigns/${code}/butler/products/recommendations?${queryStringify({ country_code, project_code, draft_name, order_id, order_item_id })}`
  },
  fetcher: client => (url, params) => {
    const { country_code, project_code, draft_name, order_id, order_item_id } = params || {}
    return client.post(url, {
      project_code,
      country_code,
      draft_name,
      order_id,
      order_item_id,
    })
  },
})

export const useApiButlerProductRecommendations = useRequest
export const preloadButlerProductRecommendations = preload
